<template>
<div id="container">
   <div class="locationWrap partner" id="main">
     <div>
       <span class="inner aniBox type_right gogo"><span>D</span>ata <br><span>A</span>nalysis <br><span>M</span>arketplace for <br><span>D</span>ata<br><span>A</span>lliance</span>
       <strong class="inner locTit aniBox type_bot gogo">
         <p class="">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</p>기업협의회
       </strong>
     </div>
   </div>
   <div class="contents" >
     <div class="inner">
       <div class="subTitWrap aniBox type_left gogo" >
         <h2>기업협의회 소개</h2>
       </div>
       <!-- 운영 -->
       <div class="mcSec con_bigdata_01" id="op">
         <div class="inner">
           <div class="mainTit aniBox type_bot gogo">
             <h2>운영</h2>
             <p>전자제품 제조기업을 대상으로 기업협의회를 구성하여 빅데이터를 활용한 산업생태계를 조성합니다.</p>
           </div>
           <div class="manage_list_wrap">
             <ul class="manage_list col4">
               <li class="col_item aniBox type_bot gogo con01">
                 <p>명시성</p>
                 <div class="img_box aniBox type_cv delay01 gogo">
                   <img src="/static/images/contents/partner_icon01.png" alt="">
                 </div>
                 <p class="txtBottom">빅데이터 공동플랫폼관련 <strong>운영기준 마련</strong></p>
               </li>
               <li class="col_item aniBox type_bot gogo con02">
                 <p>개방성</p>
                 <div class="img_box aniBox type_cv delay01 gogo">
                   <img src="/static/images/contents/partner_icon02.png" alt="">
                 </div>
                 <p class="txtBottom">기업 간 데이터 <strong>공유 및 제휴모델</strong> 개발 촉진</p>
               </li>
               <li class="col_item aniBox type_bot gogo con03">
                 <p>자립성</p>
                 <div class="img_box aniBox type_cv delay01 gogo">
                   <img src="/static/images/contents/partner_icon03.png" alt="">
                 </div>
                 <p class="txtBottom">상호 협의체를 기반으로 <strong>자립화 방안</strong> 모색</p>
               </li>
               <li class="col_item aniBox type_bot gogo con04">
                 <p>확장성</p>
                 <div class="img_box aniBox type_cv delay01 gogo">
                   <img src="/static/images/contents/partner_icon04.png" alt="">
                 </div>
                 <p class="txtBottom">초기단계의 수요기업 중심에서 <strong>활용기업으로 확장</strong></p>
               </li>
             </ul>
           </div>
         </div>
       </div>
       <!-- //운영 -->
     </div>

     <!-- 명단. -->
     <div class="mcSec con_02" id="members">
       <div class="inner">
         <div class="mainTit aniBox type_bot gogo">
           <h2>명단</h2>
         </div>
         <ul class="Benner_list clearfix">
           <h3>기업협의회</h3>
          <div class = "ci_div">
            <div v-for="(listItem,index) in gridData" :key = "index" class = "item">
              <li class="aniBox type_bot type_img_scale gogo" style="width: 100%;">
              <a href="javascript:" @click.prevent="" class="org_ci" target="_blank" :title=orgName[index]>
                <img :src="'/static/images/contents/ci/'+ listItem" alt="" class="ci_img">
              </a>
            </li> 
            </div>
        </div>
         </ul>
       </div>
     </div>
     <!-- //명단 -->

     <!-- 가입신청 -->
     <div class="mcSec con_bigdata_03" id="apply">
       <div class="inner">
         <div class="mainTit aniBox type_bot gogo">
           <h2>가입신청</h2>
         </div>
         <div class="request">
           <div class="request_left">
             <span>이런 고민을 해보셨나요?</span>
           </div>
           <div class="request_right">
             <dl>
               <dt>IoT기능접목</dt>
               <dd>우리 제품에 <strong>IoT기능을 넣고 싶은데</strong> 어디서부터 시작해야 할까?</dd>
             </dl>
             <dl>
               <dt>분석, 활용</dt>
               <dd>우리 제품으로부터 <strong>데이터가 수집</strong>되고 있는데 이를 <strong>어떻게 분석하여 활용할까?</strong></dd>
             </dl>
             <dl>
               <dt>초기 도입비용</dt>
               <dd><strong>빅데이터 시스템을 구축</strong>하려면 초기 <strong>도입비용</strong>이 너무 많이 드는데, 좋은 방법은 없을까?</dd>
             </dl>
             <dl>
               <dt>실무 교육</dt>
               <dd>우리직원들이 쉽게 활용 가능한 <strong>빅데이터 실무 교육은 없을까?</strong></dd>
             </dl>
             <dl>
               <dt>새로운 비즈니스 개발</dt>
               <dd>우리 제품의 데이터와 다른 제품(혹은 서비스) 데이터를 제휴ㆍ공유하여 <strong>새로운 비즈니스를 개발하는 것은 가능할까?</strong></dd>
             </dl>
             <dl>
               <dt>해외규제</dt>
               <dd>우리 제품이 해외수출을 하는데, <strong>정보수집에 대한 해외규제는 무엇일까?</strong></dd>
             </dl>
           </div>
         </div>
         <div class="btn_area taC aniBox type_top gogo">
           <router-link to="/partner/apply" class="btn_blue" v-if="isAuthenticated">기업협의회 가입신청</router-link>
           <a class="btn_blue" v-if="!isAuthenticated" @click="loginAlert()">기업협의회 가입신청</a>
<!--            <a href="/static/files/(양식)빅데이터+기업협의회_가입신청서.docx" title="새창에서다운로드" target="_blank" class="btn_blue" >기업협의회 가입신청서(DOCX) 다운로드</a>
           <a href="/static/files/(양식)빅데이터+기업협의회_가입신청서.hwp" title="새창에서다운로드" target="_blank" class="btn_blue" >기업협의회 가입신청서(HWP) 다운로드</a> -->
         </div>
         <div class="info_mailTel">
           <h2>빅데이터 기업협의회에 가입하시면, 이 모든 지원을 받으실 수 있습니다.<br>로그인 후 기업협의회 신청 가능합니다. </h2>
           <p>E-mail : godamda@gokea.org&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;TEL : 02-6388-6111~2</p>
         </div>
       </div>
     </div>
     <!-- //운영 -->

     <!-- rightBar -->
     <aside id="rightBar">
       <ul>
         <li class="on">
           <a href="#main">
             <span class="rightbar-bullet-txt"><em>기업협의회 소개</em></span>
             <span class="bullet bullet-01"><i class="material-icons">apps</i></span>
           </a>
         </li>
         <li class="">
           <a href="#op">
             <span class="rightbar-bullet-txt"><em>기업협의회 운영</em></span>
             <span class="bullet bullet-02"><i class="material-icons">business</i></span>
           </a>
         </li>
         <li class="">
           <a href="#members">
             <span class="rightbar-bullet-txt"><em>기업협의회 명단</em></span>
             <span class="bullet bullet-03"><i class="material-icons">list_alt</i></span>
           </a>
         </li>
         <li class="">
           <a href="#apply">
             <span class="rightbar-bullet-txt"><em>기업협의회 참가신청</em></span>
             <span class="bullet bullet-03"><i class="material-icons">how_to_vote</i></span>
           </a>
         </li>
       </ul>
     </aside>
     <!-- //rightBar -->

   </div>
 </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  name: 'Partner',
  data () {
    return {
      gridData : [],
       orgName : []
    }
  },
  updated () {
    setTimeout(() => this.scrollFix(this.$route.hash), 1000)
  },
  methods: {
    scrollFix: function (hashbang) {
      location.hash = hashbang
    },
    loginAlert () {
      alert('로그인 후 기업협의회 가입신청이 가능합니다.')
    },
    loadData (no) {
      var _this = this
      var pageNo = no || 1
      var org = []
      var param = {
          pageNo: pageNo
      }
        axios.get('/web/api/org/orgFileList', {withCredentials: true, param:param})
          .then(response => {
            _this.gridData = response.data.filenames

            for(let i = 0;i<_this.gridData.length;i++) {
              org[i] = _this.gridData[i].split('.');
              _this.orgName[i] = org[i][1];
            }
          })
          .catch(e => {
            console.log('error : ', e)
          })
    },
  },
  created () {
    this.loadData(1)
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.userInfo
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.submenu {
  position: fixed;
  width:100%;
  line-height:40px;
  border-radius:3px;
  /* background: linear-gradient( to bottom, #fff, #eee ); */
  background-color : #eee;
  box-shadow:0 1px 0 0 #ddd;
}
.submenu nav ul li {
  display:inline;
  padding: 0 0 0 30px;
}
.submenu nav ul li a {
  color : #666;
}
.submenu ul {
  text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/components/Partner.vue